module.exports = __webpack_public_path__ + "img/tpc-web-6.2e72a0c0.webp";